let body;
let widget;
let isVisible = false;

function showWidget(visible) {
  // Update state.
  isVisible = visible === true;

  // Toggle body class.
  body.classList.toggle('_picking-language');

  if (isVisible === false) {
    // Deselect vehicle type.
    widget.setAttribute('data-selected-type', '');
  }
}

// On document loaded.
(() => {
  body = document.body;
  widget = document.getElementById('language-picker');
  if (widget) {
    // Close click...
    widget.getElementsByClassName('close-language-picker')[0].addEventListener('click', () => { showWidget(false); });

    // Open click...
    const openButtons = document.querySelectorAll('.change-language-button, .footer__language-select');

    for (let i = 0; i < openButtons.length; i += 1) {
      openButtons[i].addEventListener('click', () => { showWidget(false); });
    }

    // Escape key pressed.
    window.addEventListener('keydown', (event) => (event.keyCode === 27) && (isVisible === true) && showWidget(false));

    // Bind click handler to each vehicle icon.
    const vehicleButtons = widget.getElementsByClassName('select-vehicle-type');

    for (let i = 0; i < vehicleButtons.length; i += 1) {
      vehicleButtons[i].addEventListener('click', (event) => {
        const selectedVehicleType = event.currentTarget.dataset.type;
        if (document.getElementsByClassName('vehicle-type--selected')[0]) {
          document.getElementsByClassName('vehicle-type--selected')[0].classList.remove('vehicle-type--selected');
        }
        if (document.getElementsByClassName('languages--selected')[0]) {
          document.getElementsByClassName('languages--selected')[0].classList.remove('languages--selected');
        }

        event.currentTarget.classList.add('vehicle-type--selected');
        document.getElementById('language-picker').setAttribute('data-selected-type', selectedVehicleType);
        document.getElementsByClassName(`languages--${selectedVehicleType}`)[0].classList.add('languages--selected');
      });
    }
  }
})();
